import { URL_GET_ALL_CONTACTS } from 'constants/urls';

async function getAllContactsApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_ALL_CONTACTS, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getAllContactsApi;
